








































import { Vue, Component, Prop } from "vue-property-decorator";

import StatusBar from "../status-bar/StatusBar.vue";
import StateChanger from "./components/StateChanger.vue";
import SessionListInfo from "@share/program/components/session-list/session-list-info/SessionListInfo.vue";
import PlayerTitle from "@share/common/PlayerTitle.vue";
import { getCurrentStatus, getTimeString } from "../status-bar/StatusBarHelper";
import { Status } from "../status-bar/Status";
import { DateTime } from "luxon";
import { UserProfile } from "@api/models/UserProfile";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { SessionManipulationServiceInterface } from "@share/session/helpers/SessionManipulationService";
import { AgendaModel } from "@api/models/agenda/AgendaModel";
import { RootState } from "@service/store/types/RootState";
import { getDateByTimeZoneOffset } from "@common/dateTimeHelper";

@Component({
  components: { StatusBar, StateChanger, SessionListInfo, PlayerTitle },
})
export default class SessionInfo extends Vue {
  @Prop({ required: true }) session: AgendaModel;
  @Prop({ required: true }) speakers: UserProfile[];
  @Prop({ default: false }) isAdmin: boolean;
  @Prop({ default: false }) isWebConf: boolean;
  @Prop({ default: null }) sessionManipulationService: SessionManipulationServiceInterface | null;

  timer?: NodeJS.Timeout;
  currentStatus: Status = Status.empty;
  timeString = "";
  detailIsShowing = false;
  Status = Status;

  created() {
    this.watch();
  }

  activated() {
    this.watch();
  }

  deactivated() {
    this.clearTimer()
  }

  destroyed() {
    this.clearTimer()
  }

  toggleDetail() {
    this.detailIsShowing = !this.detailIsShowing
  }

  watch() {
    this.timer = setInterval(this.watchHandler, 1000);
  }

  clearTimer() {
    if(this.timer) {
      clearInterval(this.timer)
    }
  }

  watchHandler() {

    const updatedStatus = getCurrentStatus(this.session, this.isWebConf);

    //завершение сессии по времени
    if((this.currentStatus !== updatedStatus) && updatedStatus === Status.ended && this.session.onlineProvider !== OnlineProvider.pastSessionRecord) {
      this.$emit('endSessionByTime');
    }

    //начало трансляции в момент начала сесии по времени так же предотвращать событие если статус сменился в результате увеличения времени конца сессии
    if((this.currentStatus !== updatedStatus && this.currentStatus !== Status.empty) && updatedStatus === Status.started && this.currentStatus !== Status.endSoon) {
      this.$emit('startSessionByTime');
    }

    if(this.currentStatus === Status.beginSoon) {
      this.timeString = getTimeString(this.session.beginAt, true);
    }

    if(this.currentStatus === Status.endSoon || this.currentStatus === Status.started) {
      this.timeString = getTimeString(this.session.endAt, true);
    }

    this.currentStatus = updatedStatus;
  }

  startSession() {
    try {
      this.sessionManipulationService?.startSession(this.session.id);
    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
  }

  completeSession() {
    try {
      this.sessionManipulationService?.completeSession(this.session.id);
    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
  }

  updateBeginTime(minutes: number) {

    const updatedTime = this.session.beginAt.plus({ minutes: minutes });

    try {
      this.sessionManipulationService?.updateBeginTime(this.session.id, updatedTime.toISO());
    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
  }

  async updateEndTime(minutes: number) {
    const updatedTime = this.session.endAt.plus({ minutes: minutes });

    try {
      await this.sessionManipulationService?.updateEndTime(this.session.id, updatedTime.toISO());
    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
  }

  setManualControl() {
    try {
      if(!this.session.isManualControlled) {
        this.sessionManipulationService?.setManualControl(this.session.id, true);
      }
    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
  }

  /**
   * Cмещение времени окончания текущей сессии на 5 минут
   * и смещение времени начала и окончания последующих сессий на 5 минут
   */
  async setOffsetToCurrentSessions() {
    try {
      this.$store.dispatch('showSpinner');

      const ensuingSessions = this.currentProgramSessionList.filter((session) => {
        const ended = session.endAt < DateTime.local() || session.isClosed;
        const isAfterCurrent = this.session.endAt <= session.beginAt;

        //pass current session because we don't need update beginAt of current session
        const isCurrent = session.id === this.session.id;

        return !isCurrent && !ended && isAfterCurrent;
      });

      await Promise.all(
        [
          this.updateEndTime(5),
          ...ensuingSessions.map((session) => this.sessionManipulationService?.setOffsetToSession(session, 5))
        ]
      );

    }
    catch(e) {
      this.$store.dispatch('reportException', e, {root: true});
    }
    finally {
      this.$store.dispatch('hideSpinner');
    }
  }

  get selectedTimeZone() {
    return (this.$store.state as RootState).selectedTimeZoneOffset;
  }

  get time() {
    const start = getDateByTimeZoneOffset(this.session.beginAt, this.selectedTimeZone).toFormat("HH:mm")  || "";
    const end = getDateByTimeZoneOffset(this.session.endAt, this.selectedTimeZone).toFormat("HH:mm")  || "";
    return `${start} - ${end}`;
  }

  get currentProgramSessionList(): AgendaModel[] {
    return this.$store.getters["program/currentProgramSessionList"];
  }
}
